import React from "react";
import { MapPin, Loader2, ArrowRight } from "lucide-react";
import { BRANCHES, LOGO_URL } from "../constants";
import { SectionHeading, getDistance } from "../App";

interface CabangProps {
  onNavigate: (view: string, branchId?: number) => void;
  userCoords: { lat: number; lng: number } | null;
  onRequestLocation: () => void;
  isLocating: boolean;
  isMobile: boolean;
}

const Cabang: React.FC<CabangProps> = ({
  onNavigate,
  userCoords,
  onRequestLocation,
  isLocating,
  isMobile,
}) => {
  const branchesWithDistance = BRANCHES.map((b) => ({
    ...b,
    distance: userCoords
      ? getDistance(userCoords.lat, userCoords.lng, b.lat, b.lng)
      : null,
  })).sort((a, b) => (a.distance || Infinity) - (b.distance || Infinity));

  return (
    <section className="py-20 bg-slate-50 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6">
        <SectionHeading
          title="Cabang Hisana Padang"
          subtitle="Temukan Hisana terdekat dari tempat Anda."
        />
        <div className="flex gap-6 overflow-x-auto pb-10 no-scrollbar snap-x cursor-grab active:cursor-grabbing">
          {branchesWithDistance.map((branch, idx) => (
            <div
              key={branch.id}
              onClick={() => onNavigate("lokasi", branch.id)}
              className="min-w-[280px] sm:min-w-[320px] bg-white rounded-[2.5rem] p-6 shadow-xl border border-slate-100 snap-center transition-all hover:scale-[1.02] cursor-pointer group"
            >
              <div className="relative mb-6 h-40 rounded-2xl overflow-hidden bg-slate-100">
                <img
                  src={LOGO_URL}
                  className="absolute inset-0 m-auto w-24 h-24 object-contain opacity-20 grayscale group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" alt="Logo Hisana"
                />
              </div>
              <h4 className="text-xl font-serif font-black mb-2 text-slate-900">
                {branch.name}
              </h4>
              <p className="text-xs text-slate-500 line-clamp-2 mb-6 font-medium leading-relaxed">
                {branch.address}
              </p>
              <div className="flex items-center gap-2 text-[#ee1d23] font-black text-[10px] uppercase tracking-widest group-hover:gap-4 transition-all">
                LIHAT LOKASI <ArrowRight size={14} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cabang;
